var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientsCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2662 1.07874H9.28129V0.093811H8.62504V1.07874H3.37504V0.093811H2.71879V1.07874H1.73497C0.830444 1.07874 0.09375 1.81483 0.09375 2.71996V10.2674C0.09375 11.1719 0.829842 11.9086 1.73497 11.9086H10.2663C11.1708 11.9086 11.9075 11.1725 11.9075 10.2674L11.907 4.36006V2.71884C11.9064 1.81431 11.1703 1.07874 10.2663 1.07874H10.2662ZM11.25 10.2662C11.25 10.8087 10.8087 11.2501 10.2662 11.2501H1.7349C1.19131 11.2501 0.749972 10.8087 0.749972 10.2662V4.35992H11.25L11.25 10.2662ZM11.25 3.70374H0.750042V2.71881C0.750042 2.17577 1.19136 1.73388 1.73497 1.73388H2.7199V2.39013H3.37506V1.73498H8.62506V2.39123H9.28131V1.73498H10.2662C10.8087 1.73498 11.2501 2.17575 11.2501 2.7188L11.25 3.70374Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsCalendar);
export default __webpack_public_path__ + "static/media/Clients_Calendar.7a37b160d29dc5c771c2d4b06adbd957.svg";
export { ForwardRef as ReactComponent };